import { Stack } from '@mui/material'
import React from 'react'

import ServiceBillingEndDateChip from 'components/configured-service/chips/ServiceBillingEndDateChip'
import ServiceBillingStartDateChip from 'components/configured-service/chips/ServiceBillingStartDateChip'
import ServiceEndDateChip from 'components/configured-service/chips/ServiceEndDateChip'
import ServicePONumberChip from 'components/configured-service/chips/ServicePONumberChip'
import ServiceStartDateChip from 'components/configured-service/chips/ServiceStartDateChip'

type ServiceDateChipsProps = {
  serviceId?: string
}

const ServiceDateChips = ({ serviceId }: ServiceDateChipsProps = {}) => (
  <Stack alignItems="center" direction="row" flexWrap="wrap" gap={0.5}>
    <ServiceStartDateChip id={serviceId} />
    <ServiceEndDateChip id={serviceId} />
    <ServiceBillingStartDateChip id={serviceId} />
    <ServiceBillingEndDateChip id={serviceId} />
    <ServicePONumberChip id={serviceId} />
  </Stack>
)

export default ServiceDateChips
